export default __webpack_public_path__ + "static/media/20I_20J.23754e84.jpg";